import React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

const Input = ({ className, ...props }) => (<input className={classNames(styles.input, className)} {...props}/>);

export default Input;
